"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var common_1 = require("@angular/common");
var CancelButtonComponent = /** @class */ (function () {
    function CancelButtonComponent(kbService, location) {
        this.location = location;
        this.cancelAction = new core_1.EventEmitter();
        this.entityComparisonHelper = new idm_de_core_frontend_1.EntityComparisonHelper(kbService);
    }
    CancelButtonComponent.prototype.ngOnInit = function () {
        this.oldEntity = this.entity ? this.entity.clone() : null;
    };
    CancelButtonComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['entity']) {
            this.actionNotifier &&
                this.actionNotifier.subscribe(function (data) {
                    _this.dataHandler(data);
                }, function (err) { return console.error(err); });
        }
    };
    CancelButtonComponent.prototype.onClick = function () {
        this.cancelAction.emit();
    };
    CancelButtonComponent.prototype.dataHandler = function (data) {
        if (data.key === 1) {
            var serviceResponse = data.data;
            if (serviceResponse &&
                serviceResponse.getMeta() &&
                serviceResponse.getMeta().getValidations().length === 0) {
                this.oldEntity = serviceResponse.getData().clone();
            }
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], CancelButtonComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], CancelButtonComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], CancelButtonComponent.prototype, "systemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], CancelButtonComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], CancelButtonComponent.prototype, "cancelAction", void 0);
    CancelButtonComponent = __decorate([
        core_1.Component({
            selector: 'cancel-button',
            template: "\n        <button mat-raised-button [id]=\"id\" (click)=\"onClick()\">\n            {{ 'de_cancel' | sisTranslateMessage | async }}\n        </button>\n    ",
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n        <cancel-button\n            [id]=\"'%{id}'\"\n            [entity]=\"%{entity}\"\n            (cancelAction)=\"%{cancelAction}\"\n            [systemName]=\"'%{systemName}'\">\n        </cancel-button>\n    ",
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService, common_1.Location])
    ], CancelButtonComponent);
    return CancelButtonComponent;
}());
exports.CancelButtonComponent = CancelButtonComponent;
//# sourceMappingURL=cancel-button.component.js.map